// extracted by mini-css-extract-plugin
export default {"continent":"Continent_continent__iDvgi","container":"Continent_container__oELuh","img":"Continent_img__8EfLY","icon":"Continent_icon__oqS89"};